import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('isAuthenticated') === 'true';
  });
  const [authorizedLRN, setAuthorizedLRN] = useState(localStorage.getItem('authorizedLRN') || '');
  const [authorizedName, setAuthorizedName] = useState(localStorage.getItem('authorizedName') || '');

  useEffect(() => {
    if (isAuthenticated) {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('authorizedLRN', authorizedLRN);
      localStorage.setItem('authorizedName', authorizedName);
    } else {
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('authorizedLRN');
      localStorage.removeItem('authorizedName');
    }
  }, [isAuthenticated, authorizedLRN, authorizedName]);

  const login = (lrn, name) => {
    setIsAuthenticated(true);
    setAuthorizedLRN(lrn);
    setAuthorizedName(name);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setAuthorizedLRN('');
    setAuthorizedName('');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, authorizedLRN, authorizedName, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);